// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"invoices_routeHeader_3DOb1","addButton":"invoices_addButton_2quSf"};